import { z } from 'zod';

export const TriggerCodeGraphCatalogRunResponseSchema = z.object({
  accepted: z.literal(true),
});

export type TriggerCodeGraphCatalogRunResponse = z.infer<
  typeof TriggerCodeGraphCatalogRunResponseSchema
>;
